import {cms} from '@wix/document-services-implementation'

export default function () {
    return {
        initMethod: cms.initialize
    }
}
